export default {
  addedToCart: {
    id: 'product_add_to_cart_overlay_a11y',
    defaultMessage: 'Added to cart',
  },
}
